import { HttpClient } from "../HttpClient";

export default class AuthHttpClient {
  static verify(token: string): Promise<boolean> {
    return HttpClient.post<boolean>("users/jwt/verify/", { token });
  }
}
